import React, { useState, useRef, useEffect } from 'react';

const SearchBar = ({
  query,
  setQuery,
  disabled,
  stayOpen,
  placeholder,
  styles,
  onSubmit,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [queryString, setQueryString] = useState('');
  const inputRef = useRef(null);
  // if onSubmit exists it stores the query string internally
  // else it uses the "query" prop for live search
  const searchQuery = onSubmit ? queryString : query;
  const setSearchQuery = onSubmit ? setQueryString : setQuery;

  useEffect(() => {
    if (stayOpen) setIsOpen(stayOpen);
  }, [stayOpen]);

  const toggleIsOpen = () => {
    if (!stayOpen) {
      setIsOpen(!isOpen);
    }
  };

  const handleChange = (event) => setSearchQuery(event.target.value);

  const handleBlur = () => {
    if (!searchQuery) toggleIsOpen();
  };

  const clearState = () => {
    setSearchQuery('');
    inputRef.current.focus();
    if (onSubmit) onSubmit('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (onSubmit) onSubmit(searchQuery);
    inputRef.current.blur();
  };

  return (
    <div className={styles.container}>
      {isOpen ? (
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formField}>
            <input
              value={searchQuery}
              placeholder={placeholder}
              onChange={handleChange}
              onBlur={handleBlur}
              type="search"
              autoFocus
              ref={inputRef}
            />
            <button
              type="button"
              className={`${styles.clearButton} ${
                !searchQuery ? styles.hidden : ''
              } `}
              onClick={clearState}
            >
              <i className="fas fa-times-circle" />
            </button>
          </div>
        </form>
      ) : (
        <button
          className={styles.button}
          type="submit"
          onClick={toggleIsOpen}
          disabled={disabled}
        >
          <i className="far fa-search" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
